import { getAxiosClient } from "../../axios-client";
import { PutWarehousesUpdateRequestBody, putWarehousesUpdateResponse } from "./types";

const axiosClient = getAxiosClient();
export const putWarehousesUpdate = async (body: PutWarehousesUpdateRequestBody) => {
    return await axiosClient.ax.put<putWarehousesUpdateResponse>("/Warehouses/Update", body);
};
